module.exports = require ('./data-encoder.js');
